export const DEFAULT_IMAGE_URL =
    'https://a.1stdibscdn.com/dist/adhoc/auctions/auctions_sitebanner_image.jpeg';
